<template>
  <v-form onsubmit="return false;" ref="revenuShareForm">
      <v-text-field
        :label="$t('screener.film.right_holder_email.title')"
        name="rightholder"
        :rules="
            film.minimum_guarantee || film.fees || film.right_holder_share
            ? [rules.required, rules.email]
            : []
        "
        counter="250"
        type="text"
        color="primary"
        v-model="film.right_holder_email"
        :placeholder="$t('film.right_holder.email.placeholder')"
        ></v-text-field>

        <v-text-field
        :label="$t('screener.film.right_holder_share.title')"
        name="rightholder_share"
        :rules="[
            rules.floating_number,
            rules.inBetween(0, 100, film.right_holder_share)
        ]"
        type="text"
        color="primary"
        placeholder="0.00"
        v-model="film.right_holder_share"
        ></v-text-field>

        <!-- //Minimum Guarantee -->
        <v-text-field
        :label="$t('screener.film.minimum_guarantee.title')"
        name="minimum_guarantee"
        :rules="[rules.floating_number]"
        type="text"
        color="primary"
        placeholder="0.00"
        v-model="film.minimum_guarantee"
        :prefix="getCurrencySymbol(company.currency)"
        >
        <template v-slot:append>
            <v-tooltip top color="white">
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-information-outline</v-icon>
            </template>
            <div
                class="grey--text text--darken-3 body-1"
                v-html="$t('screener.save.monetization.currency.tip')"
            ></div>
            </v-tooltip>
        </template>
        </v-text-field>

        <!-- //Fees -->
        <v-text-field
        :label="$t('screener.film.fees.title')"
        name="fees"
        :rules="[rules.floating_number]"
        type="text"
        color="primary"
        placeholder="0.00"
        v-model="film.fees"
        :prefix="getCurrencySymbol(company.currency)"
        >
        <template v-slot:append>
            <v-tooltip top color="white">
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-information-outline</v-icon>
            </template>
            <div
                class="grey--text text--darken-3 body-1"
                v-html="$t('screener.save.monetization.currency.tip')"
            ></div>
            </v-tooltip>
        </template>
        </v-text-field>
  </v-form>
</template>

<script>
import rules from "@/validation";
import {currencySymbol} from "@/mixins/monetization";

export default {
    name:"MediaRevenueShareForm",
    props:{
        film:{
            type:Object,
            default:{}
        },
        company:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
            rules
        }
    },
    watch:{
        film:{
            deep:true,
            handler:function(){
                this.$emit("update:film",this.film);
            }
        }
    },
    mixins:[currencySymbol],
    methods:{
        validate(){
            return this.$refs.revenuShareForm.validate();
        }
    }
}
</script>

<style>

</style>
